module.exports = __webpack_public_path__ + "static/media/doctor3.b587e458.png";